import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { suggestions } from '../customers/marketplace/view-product-details/view-product.interface';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import { AppState } from '../shareModule/states/app.state';
import { filter } from 'rxjs';
import { User } from '../shareModule/models/user.model';
import { selectUser } from '../shareModule/states/user-details';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { RoleService } from '../shareModule/services/roles/role.service';
import { SharedService } from '../shareModule/services/shared.service';
import { CommonService } from '../shareModule/services/common.service';
import { SitePromoPopupComponent } from '../site-promo-popup/site-promo-popup.component';

@Component({
  selector: 'app-contribute-to-product',
  templateUrl: './contribute-to-product.component.html',
  styleUrl: './contribute-to-product.component.scss',
})
export class ContributeToProductComponent
  implements AfterContentChecked, OnChanges, AfterViewInit, OnInit
{
  @Input()
  productData;

  public realPrice = '';

  private modalRef: NgbModalRef;

  public surveyHowOrder = '';
  public surveyPointOfContact = '';

  private readonly SEEN_PROMO_BEFORE = 'seenPromoBefore';
  private _showPromo() {
    if (this.sharedService.isBrowser()) {
      if (this.commonService.getCookie(this.SEEN_PROMO_BEFORE)) {
        return;
      }

      setTimeout(() => {
        //if (!this.local.getUser()) {
          this.commonService.setCookie(this.SEEN_PROMO_BEFORE, 'true', 360);
          // if (!this.isMobile) {
          //   this.modalRef = this.bottomSheet.open(SitePromoPopupComponent, {
          //     panelClass: 'bottom-sheet-1',
          //   });
          // } else {
          this.modalRef = this.modalService.open(SitePromoPopupComponent, {
            size: 'md',
            centered: true,
            windowClass: 'info-modal',
          });
          // }
       // }
      }, 0);
    }
  }

  public typesOfParentCategory = [];
  public _getTypesOfParentCategory() {
    this.auth.getTypesOfCategory(this.productData?.categoryId).subscribe({
      next: (data: any) => {
        this.typesOfParentCategory = data.data;
        for (const type of this.typesOfParentCategory) {
          if (this.productData?.productTypes?.has(type.id)) {
            type.active = true;
          } else {
            type.active = false;
          }
        }
        this.cdr.detectChanges();
      },
      error: console.error,
    });
  }
  public productIsFood(productData) {
    return [11, 20, 93, 134, , 138, 9].includes(productData?.categoryId);
  }
  public showMoreSuggestionInfos = false;
  public nonFoodIndexes = [0, 1, 5, 6];
  public isShowingReviewModal = false;

  constructor(
    private local: LocalServiceService,
    private cdr: ChangeDetectorRef,
    private auth: AuthServiceService,
    private store: Store<AppState>,
    @Optional()
    private activeModal: NgbActiveModal,
    @Optional()
    private activeBottom: MatBottomSheetRef,

    private roleService: RoleService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private commonService: CommonService,
    private modalService: NgbModal,
  ) {}
  ngOnInit(): void {
   this._showPromo()
  }
  ngAfterViewInit(): void {
  //  this._setupBasedOnLogin();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this._fetchProductPoll();
    this._getTypesOfParentCategory();
    this.isShowingReviewModal = true;
  }
  public suggestions = suggestions;
  public surveyHowMuchSpend = '';

  private _clearReviewForm() {
    for (const sug of this.suggestions) {
      sug.value = 0;
    }
    this.isSatisfiedAfter = 0;
  }
  currentModaRef = null;

  @Output()
  refresh = new EventEmitter();

  public isSatisfiedAfter = 0;
  public wouldRecommend = 0;
  public get doesProductHaveVartianst(): boolean {
    return this.productData?.foodSpecs?.filter(
      (variant) => variant.value != '0',
    )?.length;
  }

  isAdmin = () => this.roleService?.roles?.userType.includes('ADMIN');

  public reviewPropExists(
    productData,
    prop: string,
    type: 'arr' | 'int' | 'obj',
  ) {
    if (!productData?.myReview) {
      return false;
    }
    const review = productData?.myReview;
    const propVal = review[prop];
    switch (type) {
      case 'arr': {
        return propVal && propVal != '[]';
      }
      case 'int': {
        return propVal;
      }
      case 'obj': {
        return propVal && propVal != '{}';
      }
      default: {
        console.error('unknown type', type);
      }
    }
  }

  public setImageOfMoreService(event) {
    if (!event.target.files || !event.target.files.length) {
      this.deleteNewPromoImage();
      return;
    }
    const file = event.target.files[0];
    if (!this.checkImageFileMime(file)) {
      return;
    }

    this.newPromoSelectedImage = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.newPromotSelectedImageConverted = reader.result;
    };
    reader.readAsDataURL(file);
  }
  @Input()
  public set isImageMode(value) {
    console.log({ value });
    if (value) {
      this.activeSuggestionChangeModalTab = 3;
      this.suggestChangeModalCurrentIndex = 2;
    } else {
      this.suggestChangeModalCurrentIndex = -1;
    }
    this.cdr.detectChanges();
  }
  public deleteNewPromoImage() {
    this.newPromoSelectedImage = null;
    this.newPromotSelectedImageConverted = null;
  }
  public suggestDescrChange = '';
  public surveyKeen = 0;
  public surveyWhyKeen = '';
  public surveyPoll = {
    isLoading: false,
    data: null,
  };
  private _fetchProductPoll() {
    this.surveyPoll.isLoading = true;
    this.auth
      .poll_fetch({ isAll: true, productId: this.productData?.id })
      .subscribe({
        next: (data: any) => {
          this.surveyPoll.data = data.body.data[0];
          this.surveyPoll.isLoading = false;
          console.log('poll data', this.surveyPoll);
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error(error);
          this.surveyPoll.isLoading = false;
          this.cdr.detectChanges();
        },
      });
  }

  public newVariantSuggestions = [];
  public addNewVariantSuggestion() {
    this.newVariantSuggestions.push({
      encodedPhoto: null,
      uploadPhoto: null,
      name: '',
      price: null,
      description: '',
    });
    this.cdr.detectChanges();
  }
  public removeNewVariantSuggestion(i) {
    this.newVariantSuggestions.splice(i, 1);
    this.cdr.detectChanges();
  }
  public newCompanyEmployees = [];
  public addNewEmployee() {
    console.log('adding new employee');
    this.newCompanyEmployees.push({
      encodedPhoto: null,
      uploadPhoto: null,
      name: '',
      title: '',
      gender: 'M',
    });
    this.cdr.detectChanges();
  }
  public openSelectNewVariantImageOf(i) {
    document.getElementById('sugNewVariant' + i).click();
  }
  public reviewsRatingSuggestion = {};

  public setSuggestedRating(event, id) {
    const value = event.target.value;
    this.reviewsRatingSuggestion[`${id}Rating`] = value;
  }

  public setSuggestedCount(event, id) {
    const value = event.target.value;
    this.reviewsRatingSuggestion[`${id}Count`] = value;
  }
  public setNewVariantImageOf(i, event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }
    if (!this.checkImageFileMime(file)) {
      return;
    }

    const fr = new FileReader();
    fr.onload = () => {
      this.newVariantSuggestions[i].encodedPhoto = fr.result;
      this.newVariantSuggestions[i].uploadPhoto = event.target.files[0];
    };
    fr.readAsDataURL(event.target.files[0]);
  }

  public selectImageOfNewEmployee(i) {
    document.getElementById('sugNewEmp' + i).click();
  }
  public setImageOfNewEmployee(i, event) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    if (!this.checkImageFileMime(file)) {
      return;
    }
    const fr = new FileReader();
    fr.onload = () => {
      this.newCompanyEmployees[i].encodedPhoto = fr.result;
      this.newCompanyEmployees[i].uploadPhoto = event.target.files[0];
    };
    fr.readAsDataURL(event.target.files[0]);
  }
  public removeEmployee(i) {
    this.newCompanyEmployees.splice(i, 1);
    this.cdr.detectChanges();
  }

  public variationPriceSuggestion = {};
  public likedVariants = new Set();
  public flaggedVariants = new Set();

  public selectSuggestChangeImage(i) {
    document.getElementById(`imgSugSelector`).click();
  }
  public deleteSuggestImage(i) {
    this.encodedSuggestImages[i] = null;
  }

  private checkImageFileMime = (f: File) => {
    const acceptedMime = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'];
    const extension = f.type;
    //console.log(f.name, extension)

    if (!acceptedMime.includes(extension)) {
      this.local.alertInfo({
        title: 'Image format',
        message: 'We currently accept jpg/png/webp only :)',
      });
      return false;
    }
    return true;
  };
  public setImageOfSuggestImages(event) {
    if (!event?.target?.files?.length) {
      //console.log('no files');
      return;
    }
    for (let i = 0; i < Math.min(event?.target?.files?.length, 4); i++) {
      const file = event.target.files[i];
      if (file) {
        //console.log('file found for ', i)
      }
      if (!this.checkImageFileMime(file)) {
        return;
      }
      this.suggestImages[i] = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.encodedSuggestImages[i] = reader.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  public currentUserPoints: any = 0;
  ngAfterContentChecked(): void {
    if (this.activeSuggestionChangeModalTab == 5) {
      this.checkReviewDescritpionOverflow();
    }
    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((response: User) => {
        this.currentUserPoints = response?.points ?? '0';
        ////////console.log('profile is', this.profileInfo2)
      });
  }

  public newPromoSelectedImage = null;
  public newPromotSelectedImageConverted = null;

  public isReviewShowingFullDescritpion = false;
  public doesReviewDescriptionPassline = false;
  private linesInElement(element: Element) {
    const style = window.getComputedStyle(element);
    const lineHeight = parseFloat(style.lineHeight);
    const height = element.clientHeight;

    return Math.floor(height / lineHeight);
  }
  private _descrOverFlowChecked = false;

  public checkReviewDescritpionOverflow() {
    this.doesReviewDescriptionPassline = this._doesReviewDescriptionPassline;
  }
  private get _doesReviewDescriptionPassline(): boolean {
    const elem = document.getElementById('reviewDescr');
    if (!elem || this._descrOverFlowChecked) {
      return this.doesReviewDescriptionPassline;
    }
    if (this._descrOverFlowChecked) {
      return;
    }
    this._descrOverFlowChecked = true;
    return this.linesInElement(elem) > 5;
  }

  @ViewChild('suggestChangeModal') suggestChangeModal: TemplateRef<any>;
  public suggestChangeModalCurrentIndex = -1;

  public activeSuggestionChangeModalTab = 1;
  public encodedSuggestImages = [null, null, null, null, null];
  public suggestImages = [null, null, null, null, null];

  public howToVariants = new Set();
  public howToText = '';
  private _submitHowTo() {
    if (this.howToText) {
      if (this.howToVariants.size == 0) {
        this.toastr.error('Please select at least one variant on how to tab');
        throw new Error('invalid how to variant size');
      }
      this.auth
        .marketplace_forum_shop_store_reply({
          title: 'How to ' + this.productData?.name,
          forumId: this.productData?.forum?.id,
          message:
            this.howToText +
            `  (For Variants: ${Array.from(this.howToVariants).join(',')})`,
        })
        .subscribe({
          error: console.error,
        });
    }
  }

  public submitReview() {
    const filesToBeUpload = [
      ...this.suggestImages.filter((i) => i),
      ...this.newVariantSuggestions.map((i) => i.uploadPhoto),
    ];
    for (const file of filesToBeUpload) {
      if (!this.checkImageFileMime(file)) {
        return;
      }
    }
    //console.log('here')

    const payload = new FormData();
    payload.append('memberProductId', this.productData?.id);
    payload.append('descriptionChanges', this.suggestDescrChange);
    if (this.realPrice) {
      payload.append('realPrice', this.realPrice.toString());
    }
    this._submitHowTo();

    // payload.append('priceSuggestion', this.suggestions[0].value?.toString());
    for (const suggestion of this.suggestions) {
      payload.append(suggestion.apiName, suggestion.value.toString());
    }
    payload.append(
      'likedVariants',
      JSON.stringify(Array.from(this.likedVariants)),
    );
    payload.append(
      'flaggedVariants',
      JSON.stringify(Array.from(this.flaggedVariants)),
    );
    payload.append(
      'reviewsRatingSuggestion',
      JSON.stringify(this.reviewsRatingSuggestion),
    );
    payload.append(
      'variationPriceSuggestion',
      JSON.stringify(this.variationPriceSuggestion),
    );
    if (this.isSatisfiedAfter) {
      payload.append('isSatisfiedAfter', this.isSatisfiedAfter.toString());
    }
    if (this.wouldRecommend) {
      payload.append('wouldRecommend', this.wouldRecommend.toString());
    }

    const imgNameSuff = ['One', 'Two', 'Three', 'Four'];

    for (let i = 1; i < this.suggestImages.length; i++) {
      if (this.suggestImages[i]) {
        const KEY = `image${imgNameSuff[i - 1]}`;
        //console.log(KEY, 'appended ');
        payload.append(KEY, this.suggestImages[i]);
      }
    }

    let i = 0;
    payload.append(
      'newVariantSuggestions',
      JSON.stringify(
        this.newVariantSuggestions.map((sugg) => {
          payload.append('imageNewVariant' + i++, sugg.uploadPhoto);
          delete sugg.encodedPhoto;
          delete sugg.uploadPhoto;
          return {
            ...sugg,
          };
        }),
      ),
    );

    i = 0;
    payload.append(
      'newCompanyEmployees',
      JSON.stringify(
        this.newCompanyEmployees.map((emp) => {
          payload.append('imageNewEmployee' + i++, emp.uploadPhoto);
          delete emp.encodedPhoto;
          delete emp.uploadPhoto;
          return {
            ...emp,
          };
        }),
      ),
    );

    if (this.newPromoSelectedImage && this.newPromoServiceComment) {
      payload.append('promoImage', this.newPromoSelectedImage);
      payload.append(
        'promoSuggestion',
        JSON.stringify({
          serviceComment: this.newPromoServiceComment,
          serviceDescription: this.newPromoServiceDescription,
          iconText: this.newPromoIconText,
          expiryInString: this.newPromoExpiryInString,
          allowRefer: this.newPromoAllowRefer,
          referAmount: this.newPromotReferAmount,
        }),
      );
    } else if (
      [
        this.newPromoServiceComment,
        this.newPromoServiceDescription,
        this.newPromoSelectedImage,
        this.newPromotReferAmount,
      ].some((x) => x)
    ) {
      //incomplete information
      this.local.alertInfo({
        title: 'Incomplete info',
        message:
          'Please Make Sure The Image and Title In promotion Suggestion Tab Is Complete',
      });
      return;
    }
    try {
      payload.append(
        'suggestedTypes',
        JSON.stringify(
          this.typesOfParentCategory
            .filter(
              (t) => !this.productData?.productTypes?.has(t.id) && t.active,
            )
            ?.map((t) => t.name) ?? [],
        ),
      );
    } catch (e) {
      console.error(e);
    }

    payload.append('keen', this.surveyKeen.toString());
    payload.append('whyKeen', this.surveyWhyKeen);
    payload.append('howMuch', this.surveyHowMuchSpend);

    payload.append('howOrder', this.surveyHowOrder);
    payload.append('pointOfContact', this.surveyPointOfContact);

    this.auth.addMemberProductReview(payload).subscribe({
      next: () => {
        //this.toastr.success('Suggestion sent!');

        this.suggestDescrChange = '';
        this.suggestions[0].value = 2;
        this.encodedSuggestImages = [null, null, null, null, null];
        this.refresh.next(true);
        this._clearReviewForm();
        this.closeActiveModal();
      },
      error: (err) => {
        console.error(err);
        //this.toastr.error(err.error.message);
      },
    });
  }
  public closeActiveModal() {
    this.activeBottom?.dismiss();
    this.activeModal?.dismiss();
  }

  public readonly newPromoImageSelectorId = 'newPromoImageSelector';
  public selectMoreImageNewPromoImage() {
    document.getElementById(this.newPromoImageSelectorId).click();
  }

  // public readonly newPromoImageAttachName = 'imgMoreService1';
  public expiryStringChanged(event, i) {
    const value = event.target?.value;
    this.newPromoExpiryInString = value;
  }

  public moreServiceIcons = [
    'fa-solid fa-crown',
    'fa fa-thumbs-up',
    'fas fa-gem',
    'fa-solid fa-lightbulb',
    'fa-solid fa-trophy',
    'fa-solid fa-fire',
    'fa-solid fa-medal',
    'fa-solid fa-heart',
    'fa-solid fa-trophy',
    'fas fa-bolt',
  ];

  public newPromoServiceComment = '';
  public newPromoServiceDescription = '';
  public newPromoIconText = '';
  public newPromoExpiryInString = '1 Week';
  public newPromoAllowRefer = 0;
  public newPromotReferAmount = 0;
  public encodedMorePromoBuffer = null;

  private _resetNewPromoFields(): void {
    this.newPromoServiceComment = null;
    this.newPromoServiceDescription = '';
    this.newPromoIconText = null;
    this.newPromoExpiryInString = null;
    this.newPromoAllowRefer = null;
    this.newPromotReferAmount = null;
    this.encodedMorePromoBuffer = null;
  }
}
